import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { listCalendarMonthKeys, toUtcDateString } from "#/server/game/dailyMapIds";
import { gameContextMiddleware } from "#/server/game/gameContextMiddleware";

export const loadArchiveIndexData = createServerFn({ method: "GET" })
  .middleware([gameContextMiddleware])
  .handler(async ({ context }) => {
    setRouteAction("archive_index");
    const { entitlements } = context.gameContext;
    const todayStr = toUtcDateString(new Date());

    if (entitlements.tier === "free") {
      return {
        tier: "free" as const,
        todayStr,
      };
    }

    return {
      tier: "premium" as const,
      todayStr,
      monthKeys: listCalendarMonthKeys(new Date()),
    };
  });
